const start = () => {
  require('babel-polyfill')
  require('isomorphic-fetch')
  window.Promise = require('../common/configure/bluebird')

  require('./main')
}
start()



// WEBPACK FOOTER //
// ./src/browser/index.js